module.exports = __webpack_public_path__ + "static/sec4-bg-sm-946c130bc9fb8cafb925487b4c91fa8a.jpg";